import Gardener from 'scoreboard/components/gardener'
import * as d3 from 'd3-selection'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'
import globals from 'scoreboard/components/globals'
import formatValue from 'scoreboard/components/format-value'

const ImageGardener = Gardener.extend({

	className: 'gardener image-gardener',

	_treeOptions() {
		let options = Gardener.prototype._treeOptions.apply(this, arguments)
		options.label = (selection) => {
			let tree = this.tree
			selection.each(function (data) {
				let node = tree.nodes[data.id]
				let label = d3.select(this)

				// TranslateX value of nested nodes will push a node of 100% width too far to
				// the right causing misaligned labels. Compensate by adding padding-right equal
				// to that translateX value.
				let nodeContents = d3.select(label.node().parentNode)
				let translateXValue = nodeContents.datum()._x
				label.attr('style', `padding-right: ${translateXValue}px`)

				if (node.type === 'folder') {
					// Insert image-count before the folder-name, so the folder-name can
					// take up the remaining space and have an ellipsis if there isn't enough room.
					label.selectAll('.image-count').data(d => [tree.nodes[d.id].numImages])
						.enter()
						.append('span')
						.attr('class', 'image-count')
						.text(count => {
							let formatted = formatValue({ value: count })
							return i18n.get('documents.image.count', formatted)
						})

					label.selectAll('.folder-name').data(d => [tree.nodes[d.id].label])
						.enter()
						.append('span')
						.attr('class', 'folder-name')
						.text(String)
				} else {
					label.selectAll('.thumbnail').data(d => [tree.nodes[d.id]])
						.enter()
						.append('div')
						.attr('class', d => {
							let direction = ''
							if (d.height > 40 || d.width > 40) {
								direction = d.height >= d.width ? 'vertical' : 'horizontal'
							}
							return `thumbnail ${direction}`
						})
						.attr('style', d => {
							// note the database needs to be included or else
							// images from different databases will get cached
							// incorrectly
							let url = scoreboardUrl(`api/images/${d.revisionId}/thumbnail?database=${globals.databaseId}`)
							return `background-image: url(${url})`
						})

					label.selectAll('.image-name').data(d => [tree.nodes[d.id].label])
						.enter()
						.append('span')
						.attr('class', 'image-name')
						.text(String)

					label.selectAll('.image-size').data(d => {
							let node = tree.nodes[d.id]
							if (_.isNil(node.width) || _.isNil(node.height)) {
								// Some images, such as SVGs, won't have a width/height
								return []
							}
							return [node]
						})
						.enter()
						.append('span')
						.attr('class', 'image-size')
						.text(d => i18n.get('documents.image.size', d.width, d.height))
				}
			})
		}
		options.performanceThreshold = 10
		options.height = 55 // Node height, must match image-gardener.scss.
		return options
	},

	_treeNodeClassName (node) {
		node.className = node.type
		return node
	},

	add(model, relativeId) {
		// after uploading a new image, be sure to properly set the className
		let attributes = _.clone(model.attributes)
		attributes.className = model.get('type')
		Gardener.prototype.add.call(this, attributes, relativeId)
	}

})

export default ImageGardener

ImageGardener.__filename__ = 'components/files/image-gardener.js'
